export const propertyIconSize = { width: 32, height: 30 };
export const propertySelectedIconSize = { width: 40, height: 43 };
export const printableListingIconSize = { width: 44, height: 30 };

export const infraIconSize = { width: 32, height: 32 };
export const infraSelectedIconSize = { width: 43, height: 43 };

export const propertyIconBorderRadius = 4;
